import type { Theme } from '@mui/material';
import { MAIN_LAYOUT_PX } from '../../assets/constants/index.tsx';

export const getButtonSx = (theme: Theme) => ({
  width: '100%',
  background: theme.palette.dark,
  mt: 10,
  py: 8,
  px: 12,
  borderRadius: 8,
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  color: theme.palette.white_100,
});
export const promoButtonSx = { alignItems: 'start' };

export const backButtonSx = { position: 'absolute', bottom: 64, left: MAIN_LAYOUT_PX * 4 };
export const getWrapperSx = (theme: Theme) => ({
  overflow: 'hidden',
  background: theme.palette.bg,
  height: '100%',
  position: 'relative',
  pb: 3.5,
  pt: 20,
  px: MAIN_LAYOUT_PX,
});
export const getPromoAppliedFieldSx = (theme: Theme) => ({
  px: 10,
  py: 8,
  background: theme.palette.white_20,
  color: theme.palette.white_100,
  borderRadius: 6,
  alignItems: 'center',
});
export const getLineSx = (theme: Theme) => ({
  position: 'absolute',
  background: theme.palette.juicy_orange_grad,
  height: '12px',
  width: '100%',
  borderRadius: 3,
  top: 'calc(50% - 12px)',
  rotate: '-15deg',
});